import {
  Box,
  IconButton,
  styled,
  TableBody,
  TableCell,
  TableHead,
} from '@mui/material';
import { alpha } from '@mui/system';

export const Container = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(8)} ${theme.spacing(2)}`,
}));

export const HeaderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const IconButtonContainer = styled(IconButton)(() => ({
  padding: 0,
}));

export const TitleContainer = styled(Box)(({ theme }) => ({
  height: theme.spacing(11), // 88px
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingLeft: theme.spacing(4), // 32px
}));

export const ButtonsAndInputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: theme.spacing(4), // 32px
}));

export const TableHeadStyled = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}));

export const CellHeaderStyled = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.secondary.main,
  fontWeight: 600,
}));

export const TableBodyStyled = styled(TableBody)(({ theme }) => ({
  '& td': {
    borderBottomWidth: 0,
  },
  '& .primary-item': {
    backgroundColor: alpha(theme.palette.primary.main, 0.9),
  },
  '& .secondary-item': {
    backgroundColor: alpha(theme.palette.primary.main, 0.4),
  },
  '& .tertiary-item': {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
  },
}));
